import React from 'react';
import { Route } from 'react-router';

import classifier from 'components/classifier/classifier.container';

const ClassifierRoute = (
  <Route>
		<Route
      path='/classifiers'
      component={classifier}
    >
      <Route
        path=':classifierId'
        component={classifier}
      >
      </Route>
		</Route>
  </Route>
);

export default ClassifierRoute;



// WEBPACK FOOTER //
// ./src/components/classifier/classifier.routes.jsx